import React, { FC } from "react";
import { PLAYLIST } from "../../../store/types";
import { useDropClose } from "../../../hooks";
import { addToQue, playPlaylist, clearQue } from "../../../store/actions/queue";
import { connect } from "react-redux";
import { Track } from "../../../models/track";

interface Props {
  tracks: Track[];
  addToQue: Function;
  playPlaylist: Function;
  clearQue: Function;
}

const PlaylistDrop: FC<Props> = ({
  tracks,
  addToQue,
  playPlaylist,
  clearQue,
}) => {
  useDropClose();

  return (
    <div
      className="playlist-options"
      uk-dropdown="pos: bottom-left; mode: click;delay-hide: 100"
    >
      <ul className="uk-nav uk-dropdown-nav">
        <li
          onClick={() => {
            playPlaylist(tracks);
          }}
        >
          <span>Play</span>
        </li>
        <li>
          <span>Share</span>
        </li>
        <li className="uk-nav-divider"></li>

        <li
          onClick={() => {
            addToQue({ modifier: PLAYLIST, content: tracks });
          }}
        >
          <span>Add to Que</span>
        </li>
        <li className="uk-nav-divider"></li>
        <li onClick={() => clearQue()}>
          <span>Clear Que</span>
        </li>
        <li uk-toggle="target: #que-view">
          <span>View Que</span>
        </li>
      </ul>
    </div>
  );
};

export default connect(null, { addToQue, playPlaylist, clearQue })(
  PlaylistDrop
);
